import { render, staticRenderFns } from "./MunicipalityMapParent.vue?vue&type=template&id=afa934da&"
import script from "./MunicipalityMapParent.vue?vue&type=script&lang=js&"
export * from "./MunicipalityMapParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports